
    import './styles.scoped.css';
    export default {
  "option": "awsui_option_1p2cx_1hga1_98",
  "disabled": "awsui_disabled_1p2cx_1hga1_114",
  "parent": "awsui_parent_1p2cx_1hga1_117",
  "content": "awsui_content_1p2cx_1hga1_124",
  "label-content": "awsui_label-content_1p2cx_1hga1_131",
  "label": "awsui_label_1p2cx_1hga1_131",
  "tag": "awsui_tag_1p2cx_1hga1_138",
  "label-tag": "awsui_label-tag_1p2cx_1hga1_139",
  "label-prefix": "awsui_label-prefix_1p2cx_1hga1_150",
  "tags": "awsui_tags_1p2cx_1hga1_163",
  "description": "awsui_description_1p2cx_1hga1_164",
  "icon": "awsui_icon_1p2cx_1hga1_181",
  "icon-size-big": "awsui_icon-size-big_1p2cx_1hga1_188",
  "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_1hga1_192",
  "trigger-variant": "awsui_trigger-variant_1p2cx_1hga1_207"
};
  